export default __webpack_public_path__ + "static/media/x.363a8532.svg";